import React from "react";
import isEmpty from "lodash/isEmpty";
import toNumber from "lodash/toNumber";
import axios from "axios";
import moment from "moment";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {setLoader} from "../../store/slice/dashboard";
import {errorHandle} from "../../global/errorHandle";
import GenerateQuarterlyReport from "../../components/GenerateQuarterlyReport";

const ActionButtons = (
    {
        tab,
        reportId,
        allReports,
        selectedDate,
        translations,
        selectedItem,
        reportDates,
        selectedDetails,
        parsedDetails,
        requestHeaders
    }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const viewReport = () => {
        navigate(`/online-view/${reportId?.value}`, {
            state: {
                id: reportId?.value,
                prevLocation: location?.pathname,
                selectedDetails: selectedDetails,
                date: reportId?.label,
            },
        });
    };

    const generateReport = () => {
        dispatch(setLoader(true));
        axios
            .post(`${process.env.REACT_APP_API_URL}${
                tab === 1 ? '/report/generate' :
                    tab === 2 ? `/quarterly-report/generate-document/${reportId?.value}` :
                        tab === 3 ? `/procurement-package/report/generate/${reportId?.value}` : ''
            }`, {
                report_id: reportId?.value,
                ...parsedDetails,
            }, {
                headers: requestHeaders,
                responseType: "blob",
            })
            .then(({data: blob}) => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `report_${moment(reportId?.label)?.format(
                    "dd/MM/yyyy"
                )}.docx`;
                link.click();
                dispatch(setLoader(false));
            })
            .catch((e) => {
                errorHandle(e)
                dispatch(setLoader(false));
            });
    };
    return (
        <div className="s-page__generateBtns">
            { selectedDate && tab === 1 && (
                <div onClick={viewReport} className="s-page__generate">
                    <button disabled={!selectedDate} className={`s-page__viewBtn`}>
                        {tab === 1 ?
                            translations?.['project_reports.index.actions.view_report'] :
                            translations?.['quarterly_reports.index.actions.view_report']}
                    </button>
                </div>
            )}
            { (tab === 1 || tab === 3) && (
                <div onClick={generateReport} className="s-page__generate">
                    <button
                        disabled={!selectedDate}
                        className={`s-page__generateBtn ${selectedDate ? "" : "disabled"}`}
                    >
                        {tab === 1
                            ? translations?.['project_reports.index.actions.generate_report']
                            : translations?.['procurement_reports.index.actions.generate_report']}
                    </button>
                </div>
            )}

            { (tab === 2 && !isEmpty(parsedDetails) && !isEmpty(reportDates)) && (
                <GenerateQuarterlyReport
                    reportId={reportId?.value}
                    reportData={allReports?.data?.find(item => toNumber(item?.id) === toNumber(selectedItem?.value))}
                    selectedSections={parsedDetails}
                    translations={{
                        'index.index.tooltips.generate_report_to_download': translations?.['columns.generate_report_to_download.tooltip'],
                        'index.index.titles.in_progress': translations?.['quarterly_reports.index.titles.in_progress'],
                        'index.index.tooltips.report_in_process': translations?.['columns.report_in_process.tooltip'],
                        'index.index.actions.download_report': translations?.['quarterly_reports.index.actions.download_report']
                    }}
                />
            )}
        </div>
    )

}


export default ActionButtons;
